"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const framer_motion_1 = require("framer-motion");
const smartphone_bg_png_1 = __importDefault(require("images/stock/smartphone-bg.png"));
const smartphone_png_1 = __importDefault(require("images/stock/smartphone.png"));
const AnimationSuccess_1 = __importDefault(require("./AnimationSuccess"));
/**
 * @name AnimationPhoneWait
 */
function AnimationPhoneSuccess() {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "check-phone-image", children: [(0, jsx_runtime_1.jsx)("div", { className: "phone-image", children: (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { initial: {
                        opacity: 0,
                        scale: 0.5,
                    }, animate: {
                        opacity: 1,
                        scale: 1,
                    }, transition: {
                        delay: 0.25,
                        duration: 0.5,
                    }, className: "animate-check-phone-image", children: (0, jsx_runtime_1.jsx)("img", { src: smartphone_png_1.default, alt: "phone" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "phone-animation", children: (0, jsx_runtime_1.jsx)(AnimationSuccess_1.default, { color: "#434AA0", width: "30px", height: "55px", margin: "0 auto", minHeight: "55px", maxHeight: "150px", top: "-24px", left: "8px" }) }), (0, jsx_runtime_1.jsx)("div", { className: "phone-bg", children: (0, jsx_runtime_1.jsx)("img", { src: smartphone_bg_png_1.default, alt: "phone" }) })] }));
}
exports.default = AnimationPhoneSuccess;
